import { render, staticRenderFns } from "./EventLiveChat.vue?vue&type=template&id=5086b31f&scoped=true&"
import script from "./EventLiveChat.vue?vue&type=script&lang=js&"
export * from "./EventLiveChat.vue?vue&type=script&lang=js&"
import style0 from "./EventLiveChat.vue?vue&type=style&index=0&id=5086b31f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5086b31f",
  null
  
)

export default component.exports